import type { SidebarPaneId } from '@mentimeter/editor-essentials/types';
import { TabbedInterface } from '@mentimeter/editor-properties-pane';

export const SidebarTabbedInterface = ({
  activePane,
  handleSetActiveSidebarTab,
  children,
}: {
  activePane: SidebarPaneId | '';
  handleSetActiveSidebarTab: (activePaneId: string) => void;
  children: React.ReactNode;
}) => {
  return (
    <TabbedInterface
      id="sidebar"
      activeTabId={activePane !== 'closed' ? activePane : ''}
      setActiveTabId={handleSetActiveSidebarTab}
      dismissable
    >
      {children}
    </TabbedInterface>
  );
};
